module.exports = __webpack_public_path__ + "img/bg-1-m.c50498a6.jpg";